import React from 'react';
import './index.css';
import clsx from 'classnames';
import { Link } from 'react-router-dom';
import { isEmpty } from '../../utils/utils';
import { useAppContext } from 'context';

const More = (props) => {
  const { path, clist, ...rest } = props;
  const { dispatch } = useAppContext();

  const onClick = () => {
    if (!isEmpty(clist)) {
      dispatch({
        type: 'SET_PRODUCT_TYPE',
        payload: clist[0]?.cid,
      });
    }
  };

  return (
    <div className={clsx('more')}>
      <Link className={clsx('more-btn')} to={path} {...rest} onClick={onClick}>
        查看更多
        {/* 右箭头 */}
        <svg
          viewBox='64 64 896 896'
          focusable='false'
          data-icon='right'
          fill='currentColor'
          aria-hidden='true'
          className={clsx('more-svg')}
        >
          <path d='M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z'></path>
        </svg>
      </Link>
    </div>
  );
};

export default More;
